module.exports = __webpack_public_path__ + "img/zwsj.000ed951.png";